import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Navigation from '../../Layouts/Navigation/Navigation';
import { BASE_URL } from '../../utils/constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLayerGroup, faArrowLeft, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';

const BASE = BASE_URL;

function AdminParkings() {
  const navigate = useNavigate();
  const [towers, setTowers] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchTowers();
  }, []);

  const fetchTowers = async () => {
    try {
      const res = await axios.get(`${BASE}/towers`);
      setTowers(res.data);
    } catch (e) { console.error(e); }
  };

  const handleCardClick = (id_torre) => navigate(`/controlParkings/${id_torre}`);

  return (
    <>
      <Navigation />
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 p-4 sm:p-6 lg:p-8">
        <div className="max-w-5xl mx-auto">

          {/* Back */}
          <button onClick={() => navigate('/dashboard')} className="mb-6 flex items-center gap-2 px-4 py-2 bg-white text-gray-700 rounded-lg hover:bg-gray-100 transition-colors shadow-sm">
            <FontAwesomeIcon icon={faArrowLeft} className="h-5 w-5" />
            Volver
          </button>

          <h1 className="text-4xl font-bold text-gray-800 text-center mb-10">Administrar Parqueaderos</h1>

          <div className="space-y-4">
            {/* Torre cards */}
            {towers.map((tower) => (
              <div
                key={tower.id_torre}
                onClick={() => handleCardClick(tower.id_torre)}
                className="group relative bg-white rounded-2xl shadow-md hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1 overflow-hidden cursor-pointer"
              >
                <div className="absolute inset-0 bg-gradient-to-br from-purple-500 to-indigo-600 opacity-0 group-hover:opacity-5 transition-opacity duration-300"></div>
                <div className="flex items-center justify-between p-6">
                  <div className="flex-1">
                    <h2 className="text-2xl font-bold text-gray-800 mb-2 group-hover:text-purple-600 transition-colors">{tower.nombre}</h2>
                    <p className="text-gray-600">Click para administrar los parqueaderos de esta torre</p>
                  </div>
                  <div className="relative">
                    <div className="w-20 h-20 bg-gradient-to-br from-purple-500 to-indigo-600 rounded-xl flex items-center justify-center shadow-lg transform group-hover:scale-110 group-hover:rotate-3 transition-all duration-300">
                      <FontAwesomeIcon icon={faLayerGroup} className="h-10 w-10 text-white" />
                    </div>
                  </div>
                </div>
                <div className="h-1 w-0 group-hover:w-full bg-gradient-to-r from-purple-500 to-indigo-600 transition-all duration-500"></div>
              </div>
            ))}

            {/* Externos card */}
            <div
              onClick={() => navigate('/controlExternalParkings')}
              className="group relative bg-white rounded-2xl shadow-md hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1 overflow-hidden cursor-pointer"
            >
              <div className="absolute inset-0 bg-gradient-to-br from-orange-400 to-orange-600 opacity-0 group-hover:opacity-5 transition-opacity duration-300"></div>
              <div className="flex items-center justify-between p-6">
                <div className="flex-1">
                  <h2 className="text-2xl font-bold text-gray-800 mb-2 group-hover:text-orange-500 transition-colors">Externos</h2>
                  <p className="text-gray-600">Click para administrar los parqueaderos externos</p>
                </div>
                <div className="relative">
                  <div className="w-20 h-20 bg-gradient-to-br from-orange-400 to-orange-600 rounded-xl flex items-center justify-center shadow-lg transform group-hover:scale-110 group-hover:rotate-3 transition-all duration-300">
                    <FontAwesomeIcon icon={faMapMarkerAlt} className="h-10 w-10 text-white" />
                  </div>
                </div>
              </div>
              <div className="h-1 w-0 group-hover:w-full bg-gradient-to-r from-orange-400 to-orange-600 transition-all duration-500"></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AdminParkings;

